import {Model} from "vue-mc";
import{
  required,
  string,
  length,
  email,
  numeric,
} from "vue-mc/validation"

export class Person extends Model
{
    static TYPES = {
        MEMBER: 'member',
        ACTIVE_MEMBER: 'active_member',
        NEWSLETTER_SUBSCRIBER: 'newsletter_subscriber',
        DONOR: 'donor',
        PA_OBJECTOR: 'pa_objector',
    }

    defaults() {
        return {
            id: null,
            name: null,
            surname: '',
            email: '',
            mobile: '',
            type: null,
            locality: '',
            address: '',
        }
    }

    validation() {
      return {
        name: [required, string, length(2, 100)],
        email: [required, email],
        mobile: [numeric],
        type: [required],
      }
    }

    options() {
      return {
        validateOnChange: true,
      }
    }
}
